<template>
  <div class="select-projects">
    <div
      :class="[
        'project-item d-flex align-center justify-center mt-6',
        { selected: project.name === currentProject.name },
      ]"
      v-for="project in projectItems"
      :key="project.name"
      @click="switchProject(project)"
    >
      <img
        v-if="$vuetify.theme.dark"
        :src="project.logoSmallDark || project.logoSmall"
        height="36"
        width="36"
      />
      <img v-else :src="project.logoSmall" height="36" width="36" />
      <div class="ml-4 text-5">
        <div class="font-weight-medium text-uppercase">
          {{ project.staking.token }}
        </div>
        <div class="mt-2" v-if="apyMap[project.name]">
          <span class="font-weight-medium"
            >{{
              (apyMap[project.name].apy * 100) | numberFormat("0,0.00", false)
            }}%</span
          >
          <span class="gray--text ml-1">APY</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      projects: "projectConfig/projects",
      currentProject: "projectConfig/latestProject",
      apyMap: "productStats/stakeApyMap",
    }),
    projectItems() {
      return this.projects.filter(
        item =>
          item.implemented && item.ecosystem === this.currentProject.ecosystem
      );
    },
  },
  methods: {
    switchProject(item) {
      if (item.name === this.currentProject.name) return;
      if (this.currentProject.ecosystem === "Tendermint") {
        this.$router.push({
          name: "TendermintTx",
          params: { projectName: item.name },
          query: this.$route.query,
        });
      } else {
        this.$router.push({
          path: `/stake/${item.name}/tx`,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.select-projects {
  display: grid;
  grid-template-columns: auto auto auto auto auto;
  column-gap: 15px;
  .project-item {
    height: 70px;
    border-radius: 50px;
    border: 1px solid #f2f2f2;
    &.selected {
      border-color: var(--purple);
      box-shadow: 4px 4px 8px rgba(233, 235, 255, 0.7);
    }
    &:not(.selected) {
      opacity: 0.5;
      mix-blend-mode: luminosity;
      &:hover {
        opacity: 1;
        mix-blend-mode: normal;
        border-color: var(--purple);
        background-color: #e9ebff;
        cursor: pointer;
      }
    }
  }
}
</style>
